/**
 * Slider snippet
 * 
 * @class Snippet_Slider
 * @extends Snippet
 */

Snippet_Slider = (function(Snippet) {

	var Snippet_Slider = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Snippet_Slider.prototype, Snippet_Carousel.prototype, {

		// make ul container
		makeContainer: function() {

			var container = '';
			container += '<div class="snippet-slider">';
			container += '	<div class="slider-title">{0}</div>'.format(this.collection.getTitle() || '');
			container += '	<div class="movies"><ul></ul></div>';
			container += '	<div class="preventFocus-left"></div>';
			container += '	<div class="preventFocus-right"></div>';
			container += '	<div class="arrows">';
			container += '		<div class="nav-left clickable" data-id="left"></div>';
			container += '		<div class="nav-right clickable" data-id="right"></div>';
			container += '	</div>';
			container += '</div>';

			return container;

		},

		// make li element
		makeElement: function(counter, divCounter, empty) {

			empty = empty || false;

			var element = '';
			element += ('<li data-liid="{0}" data-id="" data-counter="{0}" class="empty invisible">' +
						'	<div class="cover">' +
						'		<div class="image" style="background-image: url(\'\');"></div>' +
						'		<div class="label-wrapper">' +
						'			<span class="label"></span>' +					
						'		</div>' +
						'	</div>' +
						'</li>').format( counter );

			return element;

		},

		// update li element
		updateElement: function($li, counter) {
			var empty = (0 <= counter && counter < this.collection.length) ? false : true,		
				url = ((empty) ? '' : (this.collection.at(counter).getSliderImage() ? this.collection.at(counter).getSliderImage() : 'none'))

			if (this.loadedImages < this.assetsVisible + 2) {
				var img = new Image();
				img.onload = function () {
					++this.loadedImages;
					if (this.loadedImages === this.assetsVisible || this.loadedImages === this.collection.length) {
						this.trigger('imagesloaded');
					}
				}.bind(this);
				img.src = url;
			}

			// add remove class
			$li.toggleClass('empty', (empty) ? true : false);
			$li.toggleClass('invisible', (empty) ? true : false);

			// ids
			$li.attr('data-id',	((empty) ? '' : this.collection.at(counter).getId()));
			$li.attr('data-counter', counter);

			// image
			$('div.image', $li).css({'background-image': ((empty) ? '' : (this.collection.at(counter).getSliderImage() ? 'url(\'' + this.collection.at(counter).getSliderImage() + '\')' : 'none'))});

			// title
			var vString = this.collection.at(counter).getTitle();
			$('div.label-wrapper span', $li).html(vString.substring(0,51) + '...');
			return !empty;
		},

		onFocus: function($el) {
			this.$lastFocused = $el;
			this.parent.$lastFocused = $el;
			// this code is for mouse/kinetic input
			this.showArrows(true);
			this.parent.parent.carousel.showArrows(false);	// home.carousel.showArrows()
		}
	});

	return Snippet_Slider;

})(Snippet);


//////////////////
// WEBPACK FOOTER
// ./js/snippet/slider.js
// module id = 78
// module chunks = 0